import captcha from '../api/catpcha'
import { action } from '../utils/requests'
import { download_file } from '../api/download'

export default {
	name: 'FormDownload',
	data() {
		return {
			fields: {
				company: "",
				salutation: "",
				name: "",
				surname: "",
				phone: "",
				email: "",
			},
			captcha: '',
			captcha_image: '',
			success: false,
		}
	},
	methods: {
		submitForm() {
			captcha.validate(captcha.prefix(), this.captcha).then((success) => {
				if (success.status) {
					action('save_form', {
						fields: { ...this.fields, file: this.$refs.download_file_name.value },
						form: "form-download",
					}).then(() => {
						this.resetForm()
						this.success = true
					})

					download_file(this.$refs.download_file.value)
				} else {
					this.generateCaptcha()
				}
			})
		},
		resetForm() {
			this.fields = {}
			this.success = false
			this.generateCaptcha()
		},
		generateCaptcha() {
			this.captcha = ''
			captcha.create("#ECECEC", "#000").then((res) => {
				this.captcha_image = res.image
			})
		},
	},
}
